/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrUpdateTimecardBreakDefinitionRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {TimecardBreakDefinitionResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const createOrUpdateTimecardBreakDefinition = (request: CreateOrUpdateTimecardBreakDefinitionRequest, options?: CashRequestOptions) => post<CreateOrUpdateTimecardBreakDefinitionRequest, TimecardBreakDefinitionResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/CreateOrUpdateTimecardBreakDefinition", request, {...options, rejectOnError: true })